import { useEffect } from 'react';
import { useFormikContext } from 'formik';

 const FocusOnFirstError = () => {
  const { errors, isSubmitting } = useFormikContext();

  useEffect(() => {
    const errorKeys = Object.keys(errors);
    if (errorKeys.length > 0) {
      const firstErrorKey = errorKeys[0];
      let elementId;
      const firstError = errors[firstErrorKey];
      if (typeof firstError === 'object') {
        const errorKeySuffix = Object.keys(firstError)[0];
        elementId = `${firstErrorKey}-${errorKeySuffix}`;
      } else {
        elementId = firstErrorKey;
      }
      const element = document.getElementById(elementId);
      if (element) {
        if (element.type === 'file') {
          element.type = 'text';
          element.focus();
          element.type = 'file';
        }
        element.focus();
      }
    }
  }, [errors, isSubmitting]);
  return null;
};

export default FocusOnFirstError;